import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
}), 'CardMembershipOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CardMembershipOutlined.js
// module id = 2684
// module chunks = 2